import {getElement, getElements} from "./utils/getElement"
import {checkLicenseStatus, updateDomainsForLicense} from "./utils/license";
import {Notyf} from "notyf";

const initDomainManager = () => {
    const notyf = new Notyf();

    const modalBtns = getElements('.js-modal-trigger')
    const modalCloseBtns = getElements('.js-modal-close')

    modalBtns.map(modalBtn => {
        modalBtn.addEventListener('click', () => {
            const licenseKey = modalBtn.getAttribute('data-license-key');
            const orderId = modalBtn.getAttribute('data-order-id');
            const targetModal = modalBtn.getAttribute('data-modal-target');


            populateLicenseDomains(licenseKey, orderId, targetModal);

            getElement(`#${targetModal}`).style.display = "block"
        })
    })

    modalCloseBtns.map(modalCloseBtn => {
        modalCloseBtn.addEventListener('click', () => {
            getElements('.c-modal-wrapper').map(modal => {
                modal.style.display = "none"
                modal.querySelector('.js-modal-loading').style.display = 'flex';
            })
        })
    })

    const updateButtons = getElements('.js-update-license-domains')

    updateButtons.map(updateBtn => {
        updateBtn.addEventListener('click', async () => {
            updateBtn.disabled = true;
            const domains = [];
            const repeaterItemsContainer = updateBtn.previousElementSibling.querySelector('.js-repeater-field-items');
        
            let hasInvalidDomain = false;
        
            repeaterItemsContainer.querySelectorAll('.js-repeater-item').forEach(item => {
                const domainInput = item.querySelector('input[type="url"]');
                if (domainInput && domainInput.value) {
                    const sanitizedDomain = sanitizeDomain(domainInput.value);
                    domainInput.value = sanitizedDomain;
        
                    if (!isValidDomain(sanitizedDomain)) {
                        domainInput.classList.add('input-error');
                        hasInvalidDomain = true;
                    } else {
                        domainInput.classList.remove('input-error');
                        domains.push(sanitizedDomain);
                    }
                }
            });
        
            if (hasInvalidDomain) {
                notyf.error("Please enter valid domains (e.g., example.com), no http:// or https://.");
                updateBtn.disabled = false;
                return;
            }
        
            const licenseKey = updateBtn.getAttribute('data-license-key');
            const orderId = updateBtn.getAttribute('data-order-id');
        
            const res = await updateDomainsForLicense(licenseKey, domains, orderId);
            if (!res) {
                notyf.warning("Something went wrong! Please try again.");
            }
        
            if (res.data && res.data.status != 200) {
                notyf.error(res.message);
            } else {
                notyf.success(res.message);
            }
        
            updateBtn.disabled = false;
        });
        
    })


    document.addEventListener('DOMContentLoaded', () => {
        const modalOpenButtons = getElements('.js-open-modal');

        modalOpenButtons.forEach(button => {
            button.addEventListener('click', () => {
                const licenseKey = button.getAttribute('data-license-key');
                const orderId = button.getAttribute('data-order-id');

                // Fetch license domains and populate the modal
                fetchLicenseDomains(licenseKey, orderId);

            });
        });
    });
}

const populateLicenseDomains = async (licenseKey, orderId, targetModal) => {
    // Fetch the license domains using the provided function
    const data = await checkLicenseStatus(licenseKey, orderId);

    manageDomainInputs(targetModal, data.max_domains)

    if (data && data.license_key) {
        getElement(`#${targetModal}`).querySelector('.js-modal-loading').style.display = 'none';
    }

    const repeaterItemsContainer = getElement(`#${targetModal}`).querySelector('.js-repeater-field-items');

    // Clear existing items in the repeater field
    repeaterItemsContainer.innerHTML = '';

    // Check if there are any domains
    if (data.domains.length > 0) {
        // Populate the repeater with the fetched domains
        data.domains.forEach((domainObj, index) => {
            const newItem = document.createElement('div');
            newItem.classList.add('c-repeater-field__item', 'js-repeater-item');
            newItem.innerHTML = `
                <div class="c-repeater-field__item__counter">Website #${index + 1}</div>
                <div class="c-repeater-field__item__input">
                    <span class="c-repeater-field__item__input-prefix">https://</span>
                    <input type="text" placeholder="Enter domain" value="${domainObj.domain}" />
                </div>
                ${index > 0 ? `
                <div class="c-repeater-field__item__remove">
                    <button class="o-link o-link--icon js-repeater-remove-item">
                        <span class="o-icon o-icon--close"></span>
                    </button>
                </div>` : ''}
            `;
            repeaterItemsContainer.appendChild(newItem);

            const inputField = newItem.querySelector('input');
            inputField.addEventListener('input', (e) => {
                const sanitized = sanitizeDomain(e.target.value);
                e.target.value = sanitized;
    
                if (!isValidDomain(sanitized)) {
                    e.target.classList.add('has-error');
                } else {
                    e.target.classList.remove('has-error');
                }
            });

        });
    } else {
        // No domains exist, so we add a single empty item
        const newItem = document.createElement('div');
        newItem.classList.add('c-repeater-field__item', 'js-repeater-item');
        newItem.innerHTML = `
            <div class="c-repeater-field__item__counter">Website #1</div>
            <div class="c-repeater-field__item__input">
                <span class="c-repeater-field__item__input-prefix">https://</span>
                <input type="url" placeholder="Enter domain" />
            </div>
        `;
        repeaterItemsContainer.appendChild(newItem);

        const inputField = newItem.querySelector('input');
        inputField.addEventListener('input', (e) => {
            const sanitized = sanitizeDomain(e.target.value);
            e.target.value = sanitized;

            if (!isValidDomain(sanitized)) {
                e.target.classList.add('has-error');
            } else {
                e.target.classList.remove('has-error');
            }
        });

    }
};


const manageDomainInputs = (targetModal, maxDomains) => {
    const targetElement = getElement(`#${targetModal}`).querySelector('.js-repeater-field-items');

// Define a callback function that will be called when a mutation occurs
    const callback = (mutationsList, observer) => {
        // Loop through the mutations
        mutationsList.forEach((mutation) => {
            if (mutation.type === 'childList') {
                if (targetElement.childElementCount >= maxDomains) {
                    targetElement.parentNode.querySelector('.js-repeater-add').style.display = 'none'
                } else {
                    targetElement.parentNode.querySelector('.js-repeater-add').style.display = 'inline-block'
                }
            }
        });
    };

// Create a new MutationObserver instance and pass the callback function
    const observer = new MutationObserver(callback);

// Specify what to observe (childList: monitor changes in child elements,
// attributes: monitor changes in element's attributes, etc.)
    const config = { attributes: true, childList: true, subtree: true };

// Start observing the target element
    if (targetElement) {
        observer.observe(targetElement, config);
    } else {
        console.error("Target element not found.");
    }
}

const sanitizeDomain = (url) => {
    return url
        .replace(/^https?:\/\//i, '')  // Remove protocol
        .split('/')[0]                 // Keep only domain part before any slash
        .trim();
};

const isValidDomain = (domain) => {
    const pattern = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    return pattern.test(domain);
};

export {initDomainManager}
